var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#F3F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.5H19.75C20.1642 11.5 20.5 11.1642 20.5 10.75C20.5 10.3358 20.1642 10 19.75 10H15.75C15.3358 10 15 10.3358 15 10.75C15 11.1642 15.3358 11.5 15.75 11.5Z",
    fill: "#0065FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 17H15.75C15.3358 17 15 17.3358 15 17.75C15 18.1642 15.3358 18.5 15.75 18.5H19.75C20.1642 18.5 20.5 18.1642 20.5 17.75C20.5 17.3358 20.1642 17 19.75 17Z",
    fill: "#0065FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 24H15.75C15.3358 24 15 24.3358 15 24.75C15 25.1642 15.3358 25.5 15.75 25.5H19.75C20.1642 25.5 20.5 25.1642 20.5 24.75C20.5 24.3358 20.1642 24 19.75 24Z",
    fill: "#0065FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.6637483e0f76e67135a978ade0679880.svg";
export { ForwardRef as ReactComponent };